import { Link } from 'react-router-dom';

interface MovieCardProps {
  id: number;
  title: string;
  year: number;
  rating: number;
  genre: string;
  posterUrl: string;
  isNew?: boolean;
}

export default function MovieCard({ id, title, year, rating, genre, posterUrl, isNew }: MovieCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg bg-background-100 aspect-[2/3]">
        <img
          src={posterUrl}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

        {isNew && (
          <span className="absolute top-2 left-2 bg-accent-500 text-background-50 text-xs font-medium px-2 py-0.5 rounded-md whitespace-nowrap">
            NEW
          </span>
        )}

        <div className="absolute top-2 right-2 bg-foreground-900/75 text-accent-400 text-xs font-semibold px-1.5 py-0.5 rounded-md flex items-center gap-0.5 whitespace-nowrap">
          <div className="w-3 h-3 flex items-center justify-center">
            <i className="ri-star-fill text-[10px]"></i>
          </div>
          {rating}
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <p className="text-background-50 text-xs mb-1">{genre}</p>
          <p className="text-background-50/70 text-xs">{year}</p>
        </div>
      </div>

      <div className="mt-2.5 px-0.5">
        <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 mt-0.5">{year} · {genre}</p>
      </div>
    </Link>
  );
}